import { FC, useState, createContext, useContext, useCallback } from 'react'
import {
  QueryState,
  QueryRequestContextProps,
  initialQueryRequest,
  initialQueryState,
  SortItem,
  WithChildren,
} from '../../../../../../_metronic/helpers'

/**
 * A listagem administrativa não tem data de envio, então o id decrescente é o que coloca as
 * notificações mais recentes primeiro. Fica como `fixedSort` para sobreviver aos resets de filtro.
 */
export const ORDENACAO_NOTIFICACOES_ENVIADAS: SortItem[] = [{ field: 'id', order: 'desc' }]

export const initialNotificacoesEnviadasQueryState: QueryState = {
  ...initialQueryState,
  fixedSort: ORDENACAO_NOTIFICACOES_ENVIADAS,
}

const QueryRequestContext = createContext<QueryRequestContextProps>(initialQueryRequest)

export const QueryRequestProvider: FC<WithChildren> = ({ children }) => {
  const [state, setState] = useState<QueryState>(initialNotificacoesEnviadasQueryState)

  const updateState = useCallback((updates: Partial<QueryState>) => {
    setState((prev) => ({
      ...prev,
      ...updates,
    }))
  }, [])

  return (
    <QueryRequestContext.Provider value={{ state, updateState }}>
      {children}
    </QueryRequestContext.Provider>
  )
}

export const useQueryRequest = () => useContext(QueryRequestContext)
